"use client";

import { c as _c } from "react/compiler-runtime";
const QUICK_AMOUNT_KEYS = ["quick-vote-amount-1", "quick-vote-amount-2"] as const;
function SkeletonBlock(t0) {
  const $ = _c(2);
  const {
    className
  } = t0;
  const t1 = `tw-animate-pulse tw-rounded ${className}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
export default function MemesQuickVoteDialogSkeleton() {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="tw-sr-only">Loading your queue. Pulling unrated memes and your recent quick-vote amounts.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div data-testid="quick-vote-preview-status" className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 md:tw-hidden"><SkeletonBlock className="tw-h-8 tw-w-32 tw-rounded-full tw-bg-primary-500/15" /><SkeletonBlock className="tw-h-8 tw-w-20 tw-rounded-full tw-bg-iron-800/80" /><SkeletonBlock className="tw-h-8 tw-w-56 tw-rounded-full tw-bg-iron-800/80" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SkeletonBlock className="tw-size-11 tw-rounded-full tw-bg-iron-800/80" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-border-b tw-border-solid tw-border-white/5 tw-p-4 md:tw-hidden"><div className="tw-flex tw-items-center tw-gap-3">{t2}<div className="tw-min-w-0 tw-flex-1 tw-space-y-2"><div className="tw-flex tw-items-center tw-gap-2"><SkeletonBlock className="tw-h-4 tw-w-28 tw-bg-iron-800/80" /><SkeletonBlock className="tw-size-1 tw-rounded-full tw-bg-iron-700" /><SkeletonBlock className="tw-h-3 tw-w-12 tw-bg-iron-800/60" /></div><SkeletonBlock className="tw-h-3 tw-w-20 tw-bg-iron-800/60" /></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SkeletonBlock className="tw-mb-2 tw-h-8 tw-w-3/4 tw-bg-iron-800/80" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="md:tw-hidden">{t4}<div className="tw-mb-4 tw-space-y-2"><SkeletonBlock className="tw-h-4 tw-w-full tw-bg-iron-800/60" /><SkeletonBlock className="tw-h-4 tw-w-5/6 tw-bg-iron-800/60" /><SkeletonBlock className="tw-h-4 tw-w-2/3 tw-bg-iron-800/60" /></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="tw-flex tw-flex-col tw-gap-4">{t1}<div className="tw-relative"><article className="tw-relative tw-overflow-hidden tw-rounded-[2rem] tw-border tw-border-solid tw-border-white/10 tw-bg-iron-900/95 tw-shadow-[0_24px_60px_rgba(0,0,0,0.35)]">{t3}<div data-testid="quick-vote-preview-mobile-context" className="tw-p-4 sm:tw-p-6 md:tw-p-0">{t5}<div className="tw-overflow-hidden tw-rounded-[1.5rem] tw-bg-iron-950 md:tw-rounded-none"><div className="tw-flex tw-h-[min(52vh,28rem)] tw-items-center tw-justify-center tw-bg-iron-950/80 md:tw-h-[min(72vh,44rem)] md:tw-bg-iron-950/85"><SkeletonBlock className="tw-h-full tw-w-full tw-rounded-[1.5rem] tw-bg-iron-800/60 md:tw-rounded-none" /></div></div></div></article></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="tw-flex tw-flex-wrap tw-gap-2"><SkeletonBlock className="tw-h-8 tw-w-32 tw-rounded-full tw-bg-primary-500/15" /><SkeletonBlock className="tw-h-8 tw-w-20 tw-rounded-full tw-bg-iron-800/80" /></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SkeletonBlock className="tw-size-11 tw-rounded-full tw-bg-iron-800/80" />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="tw-flex tw-items-center tw-gap-3">{t8}<div className="tw-min-w-0 tw-flex-1 tw-space-y-2"><div className="tw-flex tw-items-center tw-gap-2"><SkeletonBlock className="tw-h-4 tw-w-28 tw-bg-iron-800/80" /><SkeletonBlock className="tw-size-1 tw-rounded-full tw-bg-iron-700" /><SkeletonBlock className="tw-h-3 tw-w-12 tw-bg-iron-800/60" /></div><SkeletonBlock className="tw-h-3 tw-w-20 tw-bg-iron-800/60" /></div></div>;
    t10 = <SkeletonBlock className="tw-mt-4 tw-h-8 tw-w-4/5 tw-bg-iron-800/80" />;
    $[9] = t10;
    $[10] = t9;
  } else {
    t10 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div data-testid="quick-vote-controls-desktop-context" className="tw-hidden tw-flex-col tw-gap-4 md:tw-flex">{t7}<div className="tw-rounded-[1.75rem] tw-border tw-border-solid tw-border-white/10 tw-bg-iron-900/70 tw-p-5">{t9}{t10}<div className="tw-mt-3 tw-space-y-2"><SkeletonBlock className="tw-h-4 tw-w-full tw-bg-iron-800/60" /><SkeletonBlock className="tw-h-4 tw-w-5/6 tw-bg-iron-800/60" /><SkeletonBlock className="tw-h-4 tw-w-2/3 tw-bg-iron-800/60" /></div></div></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="tw-flex tw-items-center tw-justify-between"><div className="tw-flex-1 tw-space-y-2"><SkeletonBlock className="tw-h-3 tw-w-20 tw-bg-iron-800/60" /><SkeletonBlock className="tw-h-4 tw-w-52 tw-bg-iron-800/60" /></div><SkeletonBlock className="tw-h-10 tw-w-28 tw-rounded-full tw-bg-iron-800/80" /></div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="tw-flex tw-flex-wrap tw-gap-2">{QUICK_AMOUNT_KEYS.map(_temp)}</div>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div role="status" aria-live="polite" aria-busy="true" data-testid="quick-vote-loading-skeleton" className="tw-grid tw-gap-6 md:tw-grid-cols-[minmax(0,1.35fr)_minmax(22rem,0.95fr)] md:tw-items-start">{t0}{t6}<div className="md:tw-sticky md:tw-top-0"><div className="tw-flex tw-flex-col tw-gap-4">{t11}{t12}{t13}<div className="tw-rounded-3xl tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-900/80 tw-p-4"><div className="tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-end"><div className="tw-min-w-0 tw-flex-1 tw-space-y-2"><SkeletonBlock className="tw-h-3 tw-w-24 tw-bg-iron-800/60" /><SkeletonBlock className="tw-h-12 tw-w-full tw-rounded-2xl tw-bg-iron-800/80" /></div><SkeletonBlock className="tw-h-12 tw-w-32 tw-rounded-2xl tw-bg-primary-500/20" /></div></div><SkeletonBlock className="tw-h-12 tw-w-full tw-rounded-2xl tw-bg-iron-800/80" /></div></div></div>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  return t14;
}
function _temp(key) {
  return <SkeletonBlock key={key} className="tw-h-10 tw-w-24 tw-rounded-full tw-bg-iron-800/80" />;
}